import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { 
  Plus, 
  Search, 
  MoreHorizontal,
  Copy,
  Pencil,
  Trash2,
  Microscope,
  Thermometer,
  Upload,
  FileText,
  Download,
  Calendar,
  X,
  Loader2,
  AlertCircle,
  Settings,
  FileDown,
  Clock,
  Bell,
  Scale,
  User
} from "lucide-react";
import { Layout } from "../components/Layout";
import { RelatorioFilterModal } from "../components/RelatorioFilterModal";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../components/ui/select";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../components/ui/dropdown-menu";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../components/ui/dialog";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../components/ui/alert-dialog";
import { Label } from "../components/ui/label";
import { Switch } from "../components/ui/switch";
import { Textarea } from "../components/ui/textarea";
import { apiRequest, formatDate, getToken, hojeBrasil, horaBrasil } from "../lib/utils";
import { Skeleton } from "../components/ui/skeleton";
import { toast } from "../components/ToastProvider";
import { AdminPasswordDialog } from "../components/AdminPasswordDialog";
import { ConfirmacaoRegistroDialog } from "../components/ConfirmacaoRegistroDialog";
import { GradeDiasVerificacao, gradePadrao, gradeDoItem } from "../components/GradeDiasVerificacao";
import { FaixaPermitidaTermo, isTermohigrometro, FAIXA_CAMPOS, avaliarFaixa, temFaixa, descreverFaixa } from "../components/FaixaPermitidaTermo";

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Categorias e setores iniciais (serão carregados do banco)
const CATEGORIAS_INICIAIS = [
  { value: "equipamento", label: "Equipamento" },
  { value: "termohigrometro", label: "Termohigrometro" },
  { value: "outros", label: "Outros" },
];

const SETORES_INICIAIS = [
  { value: "sala_limpa", label: "Sala Limpa" },
  { value: "estoque", label: "Estoque" },
  { value: "laboratorio", label: "Laboratorio" },
  { value: "geladeira", label: "Geladeira" },
  { value: "outro", label: "Outro" },
];

const initialFormData = {
  nome_item: "",
  categoria: "",
  setor: "",
  identificacao_interna: "",
  numero_serie: "",
  marca: "",
  modelo: "",
  codigo_certificado: "",
  data_ultima_calibracao: "",
  data_proxima_calibracao: "",
  periodicidade: "anual",
  ativo: true,
  verificacoes_diarias: 0,
  horarios_verificacao: [],
  horarios_por_dia: gradePadrao([]),
  faixa_temp_min: "",
  faixa_temp_max: "",
  faixa_umid_min: "",
  faixa_umid_max: "",
  responsavel_id: "",
  responsavel_nome: "",
  responsavel_email: "",
};

const sincronizarGrade = (grade, horariosAntigos, horariosNovos) =>
  Object.fromEntries(
    Object.entries(grade).map(([dia, lista]) => [
      dia,
      horariosNovos.filter((h, idx) => {
        const antigo = horariosAntigos[idx];
        return antigo === undefined ? lista.length > 0 || ["seg", "ter", "qua", "qui", "sex"].includes(dia) : lista.includes(antigo);
      }),
    ])
  );

export const ItensList = () => {
  const [itens, setItens] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [categoriaFilter, setCategoriaFilter] = useState("all");
  const [setorFilter, setSetorFilter] = useState("all");
  
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [formData, setFormData] = useState(initialFormData);
  const [saving, setSaving] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [deleteItemName, setDeleteItemName] = useState("");
  const [adminPasswordOpen, setAdminPasswordOpen] = useState(false);

  // Upload de certificados
  const [certDialogOpen, setCertDialogOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [certNome, setCertNome] = useState("");
  const [certValidade, setCertValidade] = useState("");
  const [deleteCertId, setDeleteCertId] = useState(null);
  const [deleteCertName, setDeleteCertName] = useState("");
  const [adminPasswordCertOpen, setAdminPasswordCertOpen] = useState(false);
  const fileInputRef = useRef(null);

  // Setores dinâmicos
  const [setores, setSetores] = useState([]);
  const [novoSetor, setNovoSetor] = useState("");
  const [setorDialogOpen, setSetorDialogOpen] = useState(false);
  
  // Categorias dinâmicas
  const [categorias, setCategorias] = useState([]);
  const [novaCategoria, setNovaCategoria] = useState("");
  const [categoriaDialogOpen, setCategoriaDialogOpen] = useState(false);
  const [deleteCategoriaId, setDeleteCategoriaId] = useState(null);
  const [deleteCategoriaName, setDeleteCategoriaName] = useState("");
  const [adminPasswordCatOpen, setAdminPasswordCatOpen] = useState(false);
  const [deleteSetorId, setDeleteSetorId] = useState(null);
  const [deleteSetorName, setDeleteSetorName] = useState("");
  const [adminPasswordSetorOpen, setAdminPasswordSetorOpen] = useState(false);
  
  // Upload de PDF no formulário
  const [formUploading, setFormUploading] = useState(false);
  const [formArquivo, setFormArquivo] = useState({ url: "", nome: "" });
  const formFileInputRef = useRef(null);
  
  // Relatório PDF com filtros
  const [relatorioModalOpen, setRelatorioModalOpen] = useState(false);

  // Estado para diálogo de confirmação de registro
  const [showConfirmacaoDialog, setShowConfirmacaoDialog] = useState(false);
  const [itemRecemCriado, setItemRecemCriado] = useState(null);

  // Lista de usuários para dropdown de responsável
  const [usuarios, setUsuarios] = useState([]);

  // Estados para modais de verificação após criação do item
  const [verificacaoBalancaOpen, setVerificacaoBalancaOpen] = useState(false);
  const [verificacaoTermoOpen, setVerificacaoTermoOpen] = useState(false);
  const [verificacaoSaving, setVerificacaoSaving] = useState(false);
  const [horarioVerificacaoAtual, setHorarioVerificacaoAtual] = useState(null);
  const [horariosRestantes, setHorariosRestantes] = useState([]);
  
  // Form states para verificações
  const [balancaForm, setBalancaForm] = useState({
    data_verificacao: hojeBrasil(),
    hora_verificacao: horaBrasil(),
    peso_padrao: "",
    peso_indicado: "",
    diferenca: "",
    conforme: true,
    responsavel: "",
    observacoes: "",
  });
  
  const [termoForm, setTermoForm] = useState({
    data_verificacao: hojeBrasil(),
    hora_verificacao: horaBrasil(),
    temperatura_min: "",
    temperatura_max: "",
    temperatura_lida: "",
    umidade_lida: "",
    conforme: true,
    responsavel: "",
    observacoes: "",
  });
  const termoForaFaixa = itemRecemCriado ? avaliarFaixa(itemRecemCriado, termoForm) : [];
  const atualizarTermo = (patch) => {
    const novo = { ...termoForm, ...patch };
    if (itemRecemCriado && temFaixa(itemRecemCriado)) {
      novo.conforme = avaliarFaixa(itemRecemCriado, novo).length === 0;
    }
    setTermoForm(novo);
  };

  // Função para obter o label da categoria (considerando customizadas)
  const getCategoriaNome = (categoriaValue) => {
    if (!categoriaValue) return "-";
    // Primeiro, tentar encontrar nas categorias carregadas do banco
    const found = categorias.find(c => c.value === categoriaValue || c.label === categoriaValue);
    if (found) return found.label;
    // Se não encontrou, verificar nos labels padrão
    const labelsDefault = {
      equipamento: "Equipamento",
      termohigrometro: "Termohigrômetro",
      outros: "Outros",
    };
    if (labelsDefault[categoriaValue]) return labelsDefault[categoriaValue];
    // Se parecer um UUID, retornar texto genérico
    if (categoriaValue.includes('-') && categoriaValue.length > 20) {
      return "Categoria";
    }
    return categoriaValue;
  };

  // Função para obter o label do setor (considerando customizados)
  const getSetorNome = (setorValue) => {
    if (!setorValue) return "-";
    // Primeiro, tentar encontrar nos setores carregados do banco
    const found = setores.find(s => s.value === setorValue || s.label === setorValue);
    if (found) return found.label;
    // Se não encontrou, verificar nos labels padrão
    const labelsDefault = {
      sala_limpa: "Sala Limpa",
      estoque: "Estoque",
      laboratorio: "Laboratório",
      geladeira: "Geladeira",
      outro: "Outro",
    };
    if (labelsDefault[setorValue]) return labelsDefault[setorValue];
    // Se parecer um UUID, retornar texto genérico
    if (setorValue.includes('-') && setorValue.length > 20) {
      return "Setor";
    }
    return setorValue;
  };

  useEffect(() => {
    fetchItens();
    fetchSetores();
    fetchCategorias();
    fetchUsuarios();
  }, []);

  const fetchUsuarios = async () => {
    try {
      const data = await apiRequest("/usuarios/responsaveis");
      setUsuarios(data);
    } catch (error) {
      console.error("Erro ao carregar usuários:", error);
    }
  };

  const fetchCategorias = async () => {
    try {
      const data = await apiRequest("/categorias");
      if (data && data.length > 0) {
        const categoriasOrdenadas = data
          .map(c => ({ value: c.id, label: c.nome }))
          .sort((a, b) => a.label.localeCompare(b.label, 'pt-BR'));
        setCategorias(categoriasOrdenadas);
      } else {
        // Se não houver categorias, criar as iniciais
        await initializeCategorias();
      }
    } catch (error) {
      // Se erro, criar as iniciais
      await initializeCategorias();
    }
  };

  const initializeCategorias = async () => {
    try {
      const created = [];
      for (const cat of CATEGORIAS_INICIAIS) {
        const data = await apiRequest("/categorias", {
          method: "POST",
          body: JSON.stringify({ nome: cat.label }),
        });
        created.push({ value: data.id, label: data.nome });
      }
      // Ordenar alfabeticamente
      created.sort((a, b) => a.label.localeCompare(b.label, 'pt-BR'));
      setCategorias(created);
    } catch (error) {
      console.error("Erro ao inicializar categorias:", error);
      const ordenadas = [...CATEGORIAS_INICIAIS].sort((a, b) => a.label.localeCompare(b.label, 'pt-BR'));
      setCategorias(ordenadas);
    }
  };

  const handleAddCategoria = async () => {
    if (!novaCategoria.trim()) return;
    
    try {
      const data = await apiRequest("/categorias", {
        method: "POST",
        body: JSON.stringify({ nome: novaCategoria.trim() }),
      });
      
      // Adicionar e reordenar alfabeticamente
      setCategorias(prev => {
        const updated = [...prev, { value: data.id, label: data.nome }];
        return updated.sort((a, b) => a.label.localeCompare(b.label, 'pt-BR'));
      });
      setNovaCategoria("");
      toast.success("Categoria cadastrada com sucesso!");
    } catch (error) {
      toast.error("Erro ao cadastrar categoria");
    }
  };

  const handleDeleteCategoria = async () => {
    if (!deleteCategoriaId) return;
    
    try {
      await apiRequest(`/categorias/${deleteCategoriaId}`, { method: "DELETE" });
      setCategorias(prev => prev.filter(c => c.value !== deleteCategoriaId));
      setDeleteCategoriaId(null);
      setDeleteCategoriaName("");
      toast.success("Categoria excluida!");
    } catch (error) {
      toast.error("Erro ao excluir categoria");
    }
  };

  const confirmDeleteCategoria = (cat) => {
    setDeleteCategoriaId(cat.value);
    setDeleteCategoriaName(cat.label);
    setAdminPasswordCatOpen(true);
  };

  const handleAddSetor = async () => {
    if (!novoSetor.trim()) return;
    
    try {
      const data = await apiRequest("/setores", {
        method: "POST",
        body: JSON.stringify({ nome: novoSetor.trim() }),
      });
      
      // Adicionar e reordenar alfabeticamente
      setSetores(prev => {
        const updated = [...prev, { value: data.id, label: data.nome }];
        return updated.sort((a, b) => a.label.localeCompare(b.label, 'pt-BR'));
      });
      setNovoSetor("");
      toast.success("Setor cadastrado com sucesso!");
    } catch (error) {
      toast.error("Erro ao cadastrar setor");
    }
  };

  const handleDeleteSetor = async () => {
    if (!deleteSetorId) return;
    
    try {
      await apiRequest(`/setores/${deleteSetorId}`, { method: "DELETE" });
      setSetores(prev => prev.filter(s => s.value !== deleteSetorId));
      setDeleteSetorId(null);
      setDeleteSetorName("");
      toast.success("Setor excluido!");
    } catch (error) {
      toast.error("Erro ao excluir setor");
    }
  };

  const confirmDeleteSetor = (setor) => {
    setDeleteSetorId(setor.value);
    setDeleteSetorName(setor.label);
    setAdminPasswordSetorOpen(true);
  };

  // Upload de arquivo no formulário
  const handleFormFileUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (!file.name.toLowerCase().endsWith('.pdf')) {
      toast.error("Apenas arquivos PDF são permitidos");
      return;
    }

    if (file.size > 10 * 1024 * 1024) {
      toast.error("Arquivo muito grande. Máximo 10MB.");
      return;
    }

    setFormUploading(true);
    try {
      const formDataUpload = new FormData();
      formDataUpload.append("file", file);

      const response = await fetch(`${API_URL}/api/upload`, {
        method: "POST",
        headers: { Authorization: `Bearer ${getToken()}` },
        body: formDataUpload,
      });

      if (!response.ok) throw new Error("Erro no upload");

      const result = await response.json();
      setFormArquivo({ url: result.url, nome: file.name });
      toast.success("Arquivo enviado com sucesso!");
    } catch (error) {
      toast.error("Erro ao enviar arquivo");
    } finally {
      setFormUploading(false);
    }
  };

  const fetchSetores = async () => {
    try {
      const data = await apiRequest("/setores");
      if (data && data.length > 0) {
        const setoresOrdenados = data
          .map(s => ({ value: s.id, label: s.nome }))
          .sort((a, b) => a.label.localeCompare(b.label, 'pt-BR'));
        setSetores(setoresOrdenados);
      } else {
        // Se não houver setores, criar os iniciais
        await initializeSetores();
      }
    } catch (error) {
      await initializeSetores();
    }
  };

  const initializeSetores = async () => {
    try {
      const created = [];
      for (const setor of SETORES_INICIAIS) {
        const data = await apiRequest("/setores", {
          method: "POST",
          body: JSON.stringify({ nome: setor.label }),
        });
        created.push({ value: data.id, label: data.nome });
      }
      // Ordenar alfabeticamente
      created.sort((a, b) => a.label.localeCompare(b.label, 'pt-BR'));
      setSetores(created);
    } catch (error) {
      console.error("Erro ao inicializar setores:", error);
      const ordenados = [...SETORES_INICIAIS].sort((a, b) => a.label.localeCompare(b.label, 'pt-BR'));
      setSetores(ordenados);
    }
  };

  const fetchItens = async () => {
    try {
      const data = await apiRequest("/itens");
      setItens(data);
    } catch (error) {
      console.error("Erro ao carregar itens:", error);
      toast.error("Erro ao carregar itens");
    } finally {
      setLoading(false);
    }
  };

  const handleOpenDialog = (item = null) => {
    if (item) {
      setEditingItem(item);
      setFormData({
        nome_item: item.nome_item,
        categoria: item.categoria,
        setor: item.setor,
        identificacao_interna: item.identificacao_interna || "",
        numero_serie: item.numero_serie || "",
        marca: item.marca || "",
        modelo: item.modelo || "",
        codigo_certificado: item.codigo_certificado || "",
        data_ultima_calibracao: item.data_ultima_calibracao || "",
        data_proxima_calibracao: item.data_proxima_calibracao || "",
        periodicidade: item.periodicidade || "anual",
        ativo: item.ativo,
        verificacoes_diarias: item.verificacoes_diarias || 0,
        horarios_verificacao: item.horarios_verificacao || [],
        horarios_por_dia: gradeDoItem(item),
        faixa_temp_min: item.faixa_temp_min ?? "",
        faixa_temp_max: item.faixa_temp_max ?? "",
        faixa_umid_min: item.faixa_umid_min ?? "",
        faixa_umid_max: item.faixa_umid_max ?? "",
        responsavel_id: item.responsavel_id || "",
        responsavel_nome: item.responsavel_nome || "",
        responsavel_email: item.responsavel_email || "",
      });
      setFormArquivo({ url: item.arquivo_url || "", nome: item.arquivo_nome || "" });
    } else {
      setEditingItem(null);
      // Se só tem 1 usuário, definir como responsável padrão
      const responsavelPadrao = usuarios.length === 1 ? {
        responsavel_id: usuarios[0].id,
        responsavel_nome: usuarios[0].nome,
        responsavel_email: usuarios[0].email
      } : {};
      setFormData({
        ...initialFormData,
        categoria: categorias[0]?.value || "",
        setor: setores[0]?.value || "",
        ...responsavelPadrao
      });
      setFormArquivo({ url: "", nome: "" });
    }
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setEditingItem(null);
    setFormData(initialFormData);
    setFormArquivo({ url: "", nome: "" });
  };

  const handleResponsavelChange = (userId) => {
    const usuario = usuarios.find(u => u.id === userId);
    if (usuario) {
      setFormData(prev => ({
        ...prev,
        responsavel_nome: usuario.nome,
        responsavel_id: usuario.id,
        responsavel_email: usuario.email
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);

    try {
      const payload = {
        ...formData,
        ...Object.fromEntries(FAIXA_CAMPOS.map((c) => [c, formData[c] === "" || formData[c] === undefined ? null : parseFloat(formData[c])])),
        arquivo_url: formArquivo.url || null,
        arquivo_nome: formArquivo.nome || null,
      };

      if (editingItem) {
        await apiRequest(`/itens/${editingItem.id}`, {
          method: "PUT",
          body: JSON.stringify(payload),
        });
        toast.success("Item atualizado com sucesso!");
        handleCloseDialog();
      } else {
        const novoItem = await apiRequest("/itens", {
          method: "POST",
          body: JSON.stringify(payload),
        });
        
        // Verificar se tem verificações diárias configuradas e se algum horário já passou
        const verificacoesDiarias = parseInt(formData.verificacoes_diarias) || 0;
        const diaHoje = ["dom", "seg", "ter", "qua", "qui", "sex", "sab"][new Date(new Date().toLocaleString("en-US", { timeZone: "America/Sao_Paulo" })).getDay()];
        const horarios = (formData.horarios_por_dia || gradePadrao(formData.horarios_verificacao || []))[diaHoje] || [];
        
        if (verificacoesDiarias > 0 && horarios.length > 0) {
          const agora = new Date();
          const horaAtual = `${String(agora.getHours()).padStart(2, '0')}:${String(agora.getMinutes()).padStart(2, '0')}`;
          
          // Verificar se algum horário já passou
          const horariosPassados = horarios.filter(h => h <= horaAtual);
          
          if (horariosPassados.length > 0) {
            // Tem horários que já passaram - mostrar diálogo
            setItemRecemCriado({
              ...novoItem,
              nome_item: formData.nome_item,
              horarios_verificacao: horarios,
              horarios_passados: horariosPassados,
            });
            handleCloseDialog();
            setShowConfirmacaoDialog(true);
            toast.success("Item criado!");
            fetchItens();
            return;
          }
        }
        
        toast.success("Item criado com sucesso!");
        handleCloseDialog();
      }
      fetchItens();
    } catch (error) {
      toast.error(editingItem ? "Erro ao atualizar item" : "Erro ao criar item");
    } finally {
      setSaving(false);
    }
  };

  // Função para determinar o tipo de verificação do item
  const getTipoVerificacao = (item) => {
    if (!item) return "custom";
    
    const nomeItemLower = (item.nome_item || "").toLowerCase();
    const categoriaValue = item.categoria || "";
    
    // Buscar o label da categoria
    const categoriaObj = categorias.find(c => c.value === categoriaValue);
    const categoriaLabel = categoriaObj ? categoriaObj.label.toLowerCase() : categoriaValue.toLowerCase();
    
    // Verificar se é termohigrômetro
    const isThermo = 
      nomeItemLower.includes("termo") || 
      nomeItemLower.includes("thermo") || 
      nomeItemLower.includes("higrometro") ||
      nomeItemLower.includes("higrômetro") ||
      categoriaLabel.includes("termo") || 
      categoriaLabel.includes("thermo") || 
      categoriaLabel.includes("higrometro") ||
      categoriaLabel.includes("higrômetro");
    
    if (isThermo) return "termohigrometro";
    
    // Verificar se é balança
    const isBalanca = 
      nomeItemLower.includes("balança") || 
      nomeItemLower.includes("balanca") ||
      categoriaLabel.includes("balança") || 
      categoriaLabel.includes("balanca") ||
      categoriaLabel.includes("equipamento");
    
    if (isBalanca) return "balanca";
    
    return "balanca"; // Default para equipamentos
  };

  // Handler para calcular diferença na balança
  const handleBalancaChange = (field, value) => {
    const newForm = { ...balancaForm, [field]: value };
    if (field === "peso_padrao" || field === "peso_indicado") {
      const padrao = parseFloat(newForm.peso_padrao) || 0;
      const indicado = parseFloat(newForm.peso_indicado) || 0;
      newForm.diferenca = (indicado - padrao).toFixed(4);
    }
    setBalancaForm(newForm);
  };

  // Abrir modal de verificação apropriado para o item
  const abrirModalVerificacao = (horario) => {
    if (!itemRecemCriado) return;
    
    const tipoVerif = getTipoVerificacao(itemRecemCriado);
    setHorarioVerificacaoAtual(horario);
    const agora = new Date();
    const dataAtual = hojeBrasil();
    
    if (tipoVerif === "termohigrometro") {
      setTermoForm({
        data_verificacao: dataAtual,
        hora_verificacao: horario,
        temperatura_min: "",
        temperatura_max: "",
        temperatura_lida: "",
        umidade_lida: "",
        conforme: true,
        responsavel: "",
        observacoes: "",
      });
      setVerificacaoTermoOpen(true);
    } else {
      // Balança ou outros equipamentos
      setBalancaForm({
        data_verificacao: dataAtual,
        hora_verificacao: horario,
        peso_padrao: "",
        peso_indicado: "",
        diferenca: "",
        conforme: true,
        responsavel: "",
        observacoes: "",
      });
      setVerificacaoBalancaOpen(true);
    }
  };

  // Confirmar que já realizou a verificação - abre o formulário
  const handleConfirmarVerificacoesRealizadas = async () => {
    if (!itemRecemCriado) return;
    
    // Guardar os horários que precisam ser registrados
    const horarios = [...itemRecemCriado.horarios_passados];
    setHorariosRestantes(horarios.slice(1)); // Guarda os restantes (se houver mais de um)
    
    // Fechar o diálogo de confirmação
    setShowConfirmacaoDialog(false);
    
    // Abrir o modal de verificação para o primeiro horário
    if (horarios.length > 0) {
      abrirModalVerificacao(horarios[0]);
    }
  };

  // Salvar verificação de balança
  const handleSaveVerificacaoBalanca = async () => {
    if (!itemRecemCriado) return;
    
    if (!balancaForm.peso_padrao || !balancaForm.peso_indicado || !balancaForm.responsavel) {
      toast.error("Preencha todos os campos obrigatórios");
      return;
    }
    
    setVerificacaoSaving(true);
    try {
      await apiRequest("/verificacoes/balanca", {
        method: "POST",
        body: JSON.stringify({
          item_id: itemRecemCriado.id,
          data_verificacao: balancaForm.data_verificacao,
          hora_verificacao: balancaForm.hora_verificacao,
          peso_padrao: parseFloat(balancaForm.peso_padrao),
          peso_indicado: parseFloat(balancaForm.peso_indicado),
          diferenca: parseFloat(balancaForm.diferenca),
          conforme: balancaForm.conforme,
          responsavel: balancaForm.responsavel,
          observacoes: balancaForm.observacoes,
        }),
      });
      
      toast.success(`Verificação das ${horarioVerificacaoAtual} registrada!`);
      setVerificacaoBalancaOpen(false);
      
      // Verificar se há mais horários para registrar
      if (horariosRestantes.length > 0) {
        const proximosHorarios = [...horariosRestantes];
        const proximoHorario = proximosHorarios.shift();
        setHorariosRestantes(proximosHorarios);
        
        // Pequeno delay para melhor UX
        setTimeout(() => {
          abrirModalVerificacao(proximoHorario);
        }, 300);
      } else {
        // Finalizado - limpar estados
        setItemRecemCriado(null);
        fetchItens();
      }
    } catch (error) {
      toast.error(error.message || "Erro ao salvar verificação");
    } finally {
      setVerificacaoSaving(false);
    }
  };

  // Salvar verificação de termohigrômetro
  const handleSaveVerificacaoTermo = async () => {
    if (!itemRecemCriado) return;
    
    if (!termoForm.temperatura_lida || !termoForm.temperatura_min || !termoForm.temperatura_max || !termoForm.umidade_lida || !termoForm.responsavel) {
      toast.error("Preencha todos os campos obrigatórios");
      return;
    }
    if (parseFloat(termoForm.temperatura_min) > parseFloat(termoForm.temperatura_max)) {
      toast.error("Temperatura mínima não pode ser maior que a máxima");
      return;
    }
    
    setVerificacaoSaving(true);
    try {
      const resp = await apiRequest("/verificacoes/termohigrometro", {
        method: "POST",
        body: JSON.stringify({
          item_id: itemRecemCriado.id,
          data_verificacao: termoForm.data_verificacao,
          hora_verificacao: termoForm.hora_verificacao,
          temperatura_min: parseFloat(termoForm.temperatura_min),
          temperatura_max: parseFloat(termoForm.temperatura_max),
          temperatura_lida: parseFloat(termoForm.temperatura_lida),
          umidade_lida: parseFloat(termoForm.umidade_lida),
          conforme: termoForm.conforme,
          responsavel: termoForm.responsavel,
          observacoes: termoForm.observacoes,
        }),
      });
      
      if (resp?.fora_faixa?.length > 0) {
        toast.warning(`Verificação das ${horarioVerificacaoAtual} registrada como NÃO CONFORME (fora da faixa)`);
      } else {
        toast.success(`Verificação das ${horarioVerificacaoAtual} registrada!`);
      }
      setVerificacaoTermoOpen(false);
      
      // Verificar se há mais horários para registrar
      if (horariosRestantes.length > 0) {
        const proximosHorarios = [...horariosRestantes];
        const proximoHorario = proximosHorarios.shift();
        setHorariosRestantes(proximosHorarios);
        
        // Pequeno delay para melhor UX
        setTimeout(() => {
          abrirModalVerificacao(proximoHorario);
        }, 300);
      } else {
        // Finalizado - limpar estados
        setItemRecemCriado(null);
        fetchItens();
      }
    } catch (error) {
      toast.error(error.message || "Erro ao salvar verificação");
    } finally {
      setVerificacaoSaving(false);
    }
  };

  // Pular verificação atual
  const handlePularVerificacao = () => {
    setVerificacaoBalancaOpen(false);
    setVerificacaoTermoOpen(false);
    
    // Verificar se há mais horários para registrar
    if (horariosRestantes.length > 0) {
      const proximosHorarios = [...horariosRestantes];
      const proximoHorario = proximosHorarios.shift();
      setHorariosRestantes(proximosHorarios);
      
      setTimeout(() => {
        abrirModalVerificacao(proximoHorario);
      }, 300);
    } else {
      // Finalizado
      setItemRecemCriado(null);
      toast.info("Verificações pendentes podem ser registradas posteriormente.");
    }
  };

  // Ignorar verificações do período atual
  const handleIgnorarVerificacoesHoje = async () => {
    // Não precisa fazer nada - o backend já ignora itens criados hoje
    toast.info("O sistema começará a alertar amanhã.");
  };

  const handleDuplicate = async (itemId) => {
    try {
      await apiRequest(`/itens/${itemId}/duplicar`, { method: "POST" });
      toast.success("Item duplicado com sucesso!");
      fetchItens();
    } catch (error) {
      toast.error("Erro ao duplicar item");
    }
  };

  const handleDelete = async () => {
    if (!deleteId) return;
    try {
      await apiRequest(`/itens/${deleteId}`, { method: "DELETE" });
      toast.success("Item excluido com sucesso!");
      setDeleteId(null);
      setDeleteItemName("");
      fetchItens();
    } catch (error) {
      toast.error("Erro ao excluir item");
    }
  };

  const confirmDelete = (item) => {
    setDeleteId(item.id);
    setDeleteItemName(item.nome_item);
    setAdminPasswordOpen(true);
  };

  // Funções para certificados
  const openCertDialog = (item) => {
    setSelectedItem(item);
    setCertNome("");
    setCertValidade("");
    setCertDialogOpen(true);
  };

  const handleUploadCert = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!file.name.toLowerCase().endsWith('.pdf')) {
      toast.error("Apenas arquivos PDF são permitidos");
      return;
    }

    if (!certNome.trim()) {
      toast.error("Informe o nome do certificado");
      return;
    }

    setUploading(true);

    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('nome_certificado', certNome);
      if (certValidade) {
        formData.append('validade', certValidade);
      }

      const token = localStorage.getItem('token');
      const response = await fetch(`${API_URL}/api/itens/${selectedItem.id}/certificado`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`
        },
        body: formData
      });

      if (!response.ok) {
        throw new Error('Erro ao fazer upload');
      }

      toast.success("Certificado enviado com sucesso!");
      setCertNome("");
      setCertValidade("");
      fetchItens();
      
      // Atualizar o item selecionado
      const updatedItens = await apiRequest("/itens");
      const updatedItem = updatedItens.find(i => i.id === selectedItem.id);
      setSelectedItem(updatedItem);
      
    } catch (error) {
      toast.error("Erro ao enviar certificado");
      console.error(error);
    } finally {
      setUploading(false);
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    }
  };

  const handleDownloadCert = async (itemId, filename) => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_URL}/api/itens/${itemId}/certificado/${filename}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      
      if (!response.ok) throw new Error('Erro ao baixar');
      
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove();
    } catch (error) {
      toast.error("Erro ao baixar certificado");
    }
  };

  const handleDeleteCert = async () => {
    if (!deleteCertId || !selectedItem) return;
    
    try {
      await apiRequest(`/itens/${selectedItem.id}/certificado/${deleteCertId}`, {
        method: 'DELETE'
      });
      toast.success("Certificado excluido!");
      setDeleteCertId(null);
      setDeleteCertName("");
      fetchItens();
      
      // Atualizar o item selecionado
      const updatedItens = await apiRequest("/itens");
      const updatedItem = updatedItens.find(i => i.id === selectedItem.id);
      setSelectedItem(updatedItem);
    } catch (error) {
      toast.error("Erro ao excluir certificado");
    }
  };

  const confirmDeleteCert = (cert) => {
    setDeleteCertId(cert.id);
    setDeleteCertName(cert.nome || "Certificado");
    setAdminPasswordCertOpen(true);
  };

  const filteredItens = itens.filter((item) => {
    const matchesSearch = item.nome_item.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesCategoria = categoriaFilter === "all" || item.categoria === categoriaFilter;
    const matchesSetor = setorFilter === "all" || item.setor === setorFilter;
    return matchesSearch && matchesCategoria && matchesSetor;
  });

  // Verifica se certificado esta vencido ou vencendo
  const getCertStatus = (validade) => {
    if (!validade) return null;
    const hoje = new Date();
    const venc = new Date(validade);
    const diff = Math.ceil((venc - hoje) / (1000 * 60 * 60 * 24));
    if (diff < 0) return "vencido";
    if (diff <= 30) return "vencendo";
    return "ok";
  };

  return (
    <Layout>
      <div className="space-y-6 animate-slide-in" data-testid="itens-page">
        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div>
            <h1 className="text-2xl font-bold text-slate-900" style={{ fontFamily: 'Manrope' }}>
              Itens Calibráveis
            </h1>
            <p className="text-slate-500 mt-1">Aqui você vai cadastrar os itens como termohigrômetros, balanças, termômetros e outros equipamentos que são calibrados anualmente.</p>
          </div>
          <div className="flex gap-2">
            <Button 
              variant="outline" 
              onClick={() => setRelatorioModalOpen(true)}
              data-testid="download-pdf-btn"
            >
              <FileDown className="w-4 h-4 mr-2" />
              Relatório PDF
            </Button>
            <Button 
              className="bg-teal-600 hover:bg-teal-700" 
              onClick={() => handleOpenDialog()}
              data-testid="new-item-btn"
            >
              <Plus className="w-4 h-4 mr-2" />
              Novo Item
            </Button>
          </div>
        </div>

        {/* Filters */}
        <Card>
          <CardContent className="p-4">
            <div className="flex flex-col sm:flex-row gap-4">
              <div className="relative flex-1">
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
                <Input
                  placeholder="Buscar itens..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="pl-10"
                  data-testid="search-input"
                />
              </div>
              <Select value={categoriaFilter} onValueChange={setCategoriaFilter}>
                <SelectTrigger className="w-full sm:w-48" data-testid="categoria-filter">
                  <SelectValue placeholder="Categoria" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="all">Todas categorias</SelectItem>
                  {categorias.map((cat) => (
                    <SelectItem key={cat.value} value={cat.value}>
                      {cat.label}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
              <Select value={setorFilter} onValueChange={setSetorFilter}>
                <SelectTrigger className="w-full sm:w-40" data-testid="setor-filter">
                  <SelectValue placeholder="Setor" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="all">Todos setores</SelectItem>
                  {setores.map((setor) => (
                    <SelectItem key={setor.value} value={setor.value}>
                      {setor.label}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
          </CardContent>
        </Card>

        {/* Grid */}
        {loading ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {[1, 2, 3].map((i) => (
              <Card key={i}>
                <CardContent className="p-6">
                  <Skeleton className="h-6 w-3/4 mb-2" />
                  <Skeleton className="h-4 w-1/2" />
                </CardContent>
              </Card>
            ))}
          </div>
        ) : filteredItens.length === 0 ? (
          <Card>
            <CardContent className="text-center py-12">
              <Microscope className="w-12 h-12 mx-auto text-slate-300 mb-4" />
              <h3 className="text-lg font-medium text-slate-900">Nenhum item encontrado</h3>
              <p className="text-slate-500 mt-1">
                {searchTerm || categoriaFilter !== "all" || setorFilter !== "all"
                  ? "Tente ajustar os filtros"
                  : "Comece cadastrando seu primeiro item"}
              </p>
              {!searchTerm && categoriaFilter === "all" && setorFilter === "all" && (
                <Button 
                  className="mt-4 bg-teal-600 hover:bg-teal-700"
                  onClick={() => handleOpenDialog()}
                >
                  <Plus className="w-4 h-4 mr-2" />
                  Criar item
                </Button>
              )}
            </CardContent>
          </Card>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {filteredItens.map((item) => {
              const categoriaItem = categorias.find(c => c.value === item.categoria);
              const CategoriaIcon = categoriaItem?.icon || Microscope;
              const certCount = item.certificados?.length || 0;
              
              return (
                <Card 
                  key={item.id} 
                  className="hover:shadow-md transition-all duration-200 hover:-translate-y-0.5"
                  data-testid={`item-card-${item.id}`}
                >
                  <CardContent className="p-6">
                    <div className="flex items-start justify-between mb-4">
                      <div className={`p-3 rounded-xl ${item.categoria === 'termohigrometro' ? 'bg-amber-50 text-amber-600' : 'bg-teal-50 text-teal-600'}`}>
                        <CategoriaIcon className="w-5 h-5" />
                      </div>
                      <DropdownMenu>
                        <DropdownMenuTrigger asChild>
                          <Button variant="ghost" size="icon" data-testid={`item-actions-${item.id}`}>
                            <MoreHorizontal className="w-4 h-4" />
                          </Button>
                        </DropdownMenuTrigger>
                        <DropdownMenuContent align="end">
                          <DropdownMenuItem onClick={() => handleOpenDialog(item)} className="cursor-pointer">
                            <Pencil className="w-4 h-4 mr-2" />
                            Editar
                          </DropdownMenuItem>
                          <DropdownMenuItem onClick={() => openCertDialog(item)} className="cursor-pointer">
                            <FileText className="w-4 h-4 mr-2" />
                            Certificados
                          </DropdownMenuItem>
                          <DropdownMenuItem onClick={() => handleDuplicate(item.id)} className="cursor-pointer">
                            <Copy className="w-4 h-4 mr-2" />
                            Duplicar
                          </DropdownMenuItem>
                          <DropdownMenuSeparator />
                          <DropdownMenuItem 
                            onClick={() => confirmDelete(item)}
                            className="text-red-600 cursor-pointer"
                          >
                            <Trash2 className="w-4 h-4 mr-2" />
                            Excluir
                          </DropdownMenuItem>
                        </DropdownMenuContent>
                      </DropdownMenu>
                    </div>
                    
                    <h3 className="font-semibold text-slate-900 mb-1">{item.nome_item}</h3>
                    <p className="text-sm text-slate-500 mb-2">{getSetorNome(item.setor)}</p>
                    
                    {/* Data de próxima calibração */}
                    {item.data_proxima_calibracao && (
                      <div className="flex items-center gap-1.5 mb-3">
                        <Calendar className="w-3.5 h-3.5 text-slate-400" />
                        <span className={`text-xs font-medium ${
                          (() => {
                            const hoje = new Date();
                            const venc = new Date(item.data_proxima_calibracao);
                            const diff = Math.ceil((venc - hoje) / (1000 * 60 * 60 * 24));
                            if (diff < 0) return 'text-red-600';
                            if (diff <= 30) return 'text-amber-600';
                            return 'text-slate-500';
                          })()
                        }`}>
                          Próx. calibração: {formatDate(item.data_proxima_calibracao)}
                        </span>
                      </div>
                    )}
                    
                    <div className="flex flex-wrap gap-2">
                      <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-slate-100 text-slate-600">
                        {getCategoriaNome(item.categoria)}
                      </span>
                      {item.periodicidade && (
                        <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${
                          item.periodicidade === 'nunca' ? 'bg-gray-100 text-gray-600' : 'bg-blue-50 text-blue-600'
                        }`}>
                          {item.periodicidade === 'nunca' && 'Nunca'}
                          {item.periodicidade === 'mensal' && 'Mensal'}
                          {item.periodicidade === 'bimestral' && 'Bimestral'}
                          {item.periodicidade === 'trimestral' && 'Trimestral'}
                          {item.periodicidade === 'semestral' && 'Semestral'}
                          {item.periodicidade === 'anual' && 'Anual'}
                          {item.periodicidade === 'bienal' && 'Bienal'}
                        </span>
                      )}
                      {item.identificacao_interna && (
                        <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-slate-100 text-slate-600">
                          ID: {item.identificacao_interna}
                        </span>
                      )}
                      {!item.ativo && (
                        <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-red-100 text-red-600">
                          Inativo
                        </span>
                      )}
                    </div>

                    {/* Badge de certificados */}
                    <div className="mt-4 pt-4 border-t">
                      <button 
                        onClick={() => openCertDialog(item)}
                        className="w-full flex items-center justify-between p-2 rounded-lg bg-slate-50 hover:bg-slate-100 transition-colors"
                      >
                        <div className="flex items-center gap-2">
                          <FileText className="w-4 h-4 text-slate-500" />
                          <span className="text-sm text-slate-600">Certificados</span>
                        </div>
                        <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${
                          certCount > 0 ? 'bg-teal-100 text-teal-700' : 'bg-slate-200 text-slate-500'
                        }`}>
                          {certCount}
                        </span>
                      </button>
                    </div>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        )}

        {/* Create/Edit Dialog */}
        <Dialog open={dialogOpen} onOpenChange={setDialogOpen}>
          <DialogContent className="sm:max-w-lg max-h-[90vh] overflow-y-auto">
            <DialogHeader>
              <DialogTitle style={{ fontFamily: 'Manrope' }}>
                {editingItem ? "Editar Item" : "Novo Item"}
              </DialogTitle>
              <DialogDescription>
                {editingItem ? "Atualize as informações do item" : "Preencha os dados do novo item calibrável"}
              </DialogDescription>
            </DialogHeader>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="nome_item">Nome do Item *</Label>
                <Input
                  id="nome_item"
                  value={formData.nome_item}
                  onChange={(e) => setFormData({ ...formData, nome_item: e.target.value })}
                  placeholder="Ex: Balança Analítica"
                  required
                  data-testid="input-nome"
                />
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="space-y-2">
                  <Label>Categoria *</Label>
                  <div className="flex gap-2">
                    <Select
                      value={formData.categoria}
                      onValueChange={(value) => setFormData({ ...formData, categoria: value })}
                    >
                      <SelectTrigger data-testid="select-categoria" className="flex-1 min-w-0">
                        <SelectValue />
                      </SelectTrigger>
                      <SelectContent>
                        {categorias.map((cat) => (
                          <SelectItem key={cat.value} value={cat.value}>
                            {cat.label}
                          </SelectItem>
                        ))}
                      </SelectContent>
                    </Select>
                    <Button 
                      type="button" 
                      variant="outline" 
                      size="icon"
                      className="shrink-0"
                      onClick={() => setCategoriaDialogOpen(true)}
                      title="Gerenciar categorias"
                    >
                      <Settings className="w-4 h-4" />
                    </Button>
                  </div>
                </div>

                <div className="space-y-2">
                  <Label>Setor *</Label>
                  <div className="flex gap-2">
                    <Select
                      value={formData.setor}
                      onValueChange={(value) => setFormData({ ...formData, setor: value })}
                    >
                      <SelectTrigger data-testid="select-setor" className="flex-1 min-w-0">
                        <SelectValue />
                      </SelectTrigger>
                      <SelectContent>
                        {setores.map((setor) => (
                          <SelectItem key={setor.value} value={setor.value}>
                            {setor.label}
                          </SelectItem>
                        ))}
                      </SelectContent>
                    </Select>
                    <Button 
                      type="button" 
                      variant="outline" 
                      size="icon"
                      className="shrink-0"
                      onClick={() => setSetorDialogOpen(true)}
                      title="Gerenciar setores"
                    >
                      <Settings className="w-4 h-4" />
                    </Button>
                  </div>
                </div>
              </div>

              <div className="space-y-2">
                <Label htmlFor="identificacao">Identificacao Interna</Label>
                <Input
                  id="identificacao"
                  value={formData.identificacao_interna}
                  onChange={(e) => setFormData({ ...formData, identificacao_interna: e.target.value })}
                  placeholder="Ex: BAL-001"
                />
              </div>

              <div className="space-y-2">
                <Label htmlFor="serie">Número de Serie</Label>
                <Input
                  id="serie"
                  value={formData.numero_serie}
                  onChange={(e) => setFormData({ ...formData, numero_serie: e.target.value })}
                  placeholder="Número de serie do fabricante"
                />
              </div>

              {/* Campos de Marca e Modelo */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="space-y-2">
                  <Label htmlFor="marca">Marca</Label>
                  <Input
                    id="marca"
                    value={formData.marca}
                    onChange={(e) => setFormData({ ...formData, marca: e.target.value })}
                    placeholder="Ex: Mettler Toledo"
                  />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="modelo">Modelo</Label>
                  <Input
                    id="modelo"
                    value={formData.modelo}
                    onChange={(e) => setFormData({ ...formData, modelo: e.target.value })}
                    placeholder="Ex: ME204"
                  />
                </div>
              </div>

              <div className="space-y-2">
                <Label htmlFor="codigo_certificado">Código do Certificado de Calibração</Label>
                <Input
                  id="codigo_certificado"
                  value={formData.codigo_certificado}
                  onChange={(e) => setFormData({ ...formData, codigo_certificado: e.target.value })}
                  placeholder="Ex: CERT-2025-001"
                />
              </div>

              {/* Campos de Calibração */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="space-y-2">
                  <Label htmlFor="data_ultima">Última Calibração</Label>
                  <Input
                    id="data_ultima"
                    type="date"
                    value={formData.data_ultima_calibracao}
                    onChange={(e) => setFormData({ ...formData, data_ultima_calibracao: e.target.value })}
                  />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="data_proxima">Próxima Calibração</Label>
                  <Input
                    id="data_proxima"
                    type="date"
                    value={formData.data_proxima_calibracao}
                    onChange={(e) => setFormData({ ...formData, data_proxima_calibracao: e.target.value })}
                  />
                </div>
              </div>

              <div className="space-y-2">
                <Label htmlFor="periodicidade">Periodicidade</Label>
                <Select
                  value={formData.periodicidade}
                  onValueChange={(value) => setFormData({ ...formData, periodicidade: value })}
                >
                  <SelectTrigger id="periodicidade">
                    <SelectValue placeholder="Selecione a periodicidade" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="nunca">Nunca (não vence)</SelectItem>
                    <SelectItem value="mensal">Mensal</SelectItem>
                    <SelectItem value="bimestral">Bimestral</SelectItem>
                    <SelectItem value="trimestral">Trimestral</SelectItem>
                    <SelectItem value="semestral">Semestral</SelectItem>
                    <SelectItem value="anual">Anual</SelectItem>
                    <SelectItem value="bienal">Bienal (2 anos)</SelectItem>
                  </SelectContent>
                </Select>
              </div>

              {/* Responsável */}
              <div className="space-y-2">
                <Label className="flex items-center gap-2">
                  <User className="w-4 h-4" />
                  Responsável
                </Label>
                <Select
                  value={formData.responsavel_id || ""}
                  onValueChange={handleResponsavelChange}
                >
                  <SelectTrigger data-testid="select-responsavel-item">
                    <SelectValue placeholder="Selecione o responsável" />
                  </SelectTrigger>
                  <SelectContent>
                    {usuarios.map((usuario) => (
                      <SelectItem key={usuario.id} value={usuario.id}>
                        {usuario.nome} ({usuario.email})
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
                {formData.responsavel_nome && (
                  <p className="text-xs text-slate-500">
                    Email: {formData.responsavel_email}
                  </p>
                )}
              </div>

              {isTermohigrometro(formData) && (
                <FaixaPermitidaTermo formData={formData} setFormData={setFormData} />
              )}

              {/* Verificações Diárias - Seção destacada */}
              <div className="space-y-4 p-4 bg-amber-50 rounded-lg border border-amber-200">
                <h4 className="font-medium text-amber-900 flex items-center gap-2">
                  <Bell className="w-4 h-4" />
                  Verificações Diárias
                </h4>
                <p className="text-sm text-amber-700">
                  Configure alertas para verificar este item em horários específicos do dia.
                </p>
                
                <div className="space-y-2">
                  <Label>Quantidade de verificações por dia</Label>
                  <Select
                    value={String(formData.verificacoes_diarias || 0)}
                    onValueChange={(value) => {
                      const num = parseInt(value);
                      const horarios = [...(formData.horarios_verificacao || [])];
                      // Ajustar array de horários
                      while (horarios.length < num) {
                        if (horarios.length === 0) horarios.push("08:00");
                        else if (horarios.length === 1) horarios.push("14:00");
                        else horarios.push("20:00");
                      }
                      while (horarios.length > num) {
                        horarios.pop();
                      }
                      setFormData({ 
                        ...formData, 
                        verificacoes_diarias: num,
                        horarios_verificacao: horarios,
                        horarios_por_dia: sincronizarGrade(formData.horarios_por_dia || gradePadrao([]), formData.horarios_verificacao || [], horarios)
                      });
                    }}
                  >
                    <SelectTrigger>
                      <SelectValue placeholder="Selecione" />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="0">Desabilitado</SelectItem>
                      <SelectItem value="1">1 verificação por dia</SelectItem>
                      <SelectItem value="2">2 verificações por dia</SelectItem>
                      <SelectItem value="3">3 verificações por dia</SelectItem>
                    </SelectContent>
                  </Select>
                </div>

                {formData.verificacoes_diarias > 0 && (
                  <div className="space-y-3">
                    <Label>Horários das verificações</Label>
                    <div className="grid grid-cols-3 gap-3">
                      {Array.from({ length: formData.verificacoes_diarias }).map((_, idx) => (
                        <div key={idx} className="space-y-1">
                          <Label className="text-xs text-amber-700">
                            {idx + 1}ª verificação
                          </Label>
                          <Input
                            type="time"
                            value={formData.horarios_verificacao?.[idx] || ""}
                            onChange={(e) => {
                              const newHorarios = [...(formData.horarios_verificacao || [])];
                              newHorarios[idx] = e.target.value;
                              setFormData({
                                ...formData,
                                horarios_verificacao: newHorarios,
                                horarios_por_dia: sincronizarGrade(formData.horarios_por_dia || gradePadrao([]), formData.horarios_verificacao || [], newHorarios)
                              });
                            }}
                            className="text-center bg-white"
                          />
                        </div>
                      ))}
                    </div>
                    <GradeDiasVerificacao
                      horarios={formData.horarios_verificacao || []}
                      grade={formData.horarios_por_dia || gradePadrao([])}
                      onChange={(grade) => setFormData({ ...formData, horarios_por_dia: grade })}
                    />
                  </div>
                )}
              </div>

              <div className="flex items-center gap-2">
                <Switch
                  id="ativo"
                  checked={formData.ativo}
                  onCheckedChange={(checked) => setFormData({ ...formData, ativo: checked })}
                />
                <Label htmlFor="ativo">Item ativo</Label>
              </div>

              {/* Upload de PDF */}
              <div className="space-y-2">
                <Label>Documento PDF (opcional)</Label>
                {formArquivo.url ? (
                  <div className="flex items-center gap-3 p-3 bg-slate-50 rounded-lg">
                    <FileText className="w-6 h-6 text-teal-600" />
                    <div className="flex-1 min-w-0">
                      <p className="text-sm font-medium text-slate-900 truncate">{formArquivo.nome}</p>
                      <a 
                        href={`${API_URL}${formArquivo.url}`} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="text-xs text-teal-600 hover:underline"
                      >
                        Visualizar
                      </a>
                    </div>
                    <Button 
                      type="button" 
                      variant="ghost" 
                      size="icon"
                      onClick={() => setFormArquivo({ url: "", nome: "" })}
                    >
                      <X className="w-4 h-4" />
                    </Button>
                  </div>
                ) : (
                  <div 
                    className="border-2 border-dashed border-slate-200 rounded-lg p-4 text-center hover:border-teal-400 transition-colors cursor-pointer"
                    onClick={() => formFileInputRef.current?.click()}
                  >
                    <input
                      ref={formFileInputRef}
                      type="file"
                      className="hidden"
                      accept=".pdf"
                      onChange={handleFormFileUpload}
                    />
                    {formUploading ? (
                      <Loader2 className="w-6 h-6 mx-auto text-teal-600 animate-spin" />
                    ) : (
                      <Upload className="w-6 h-6 mx-auto text-slate-400" />
                    )}
                    <p className="mt-1 text-sm text-slate-600">
                      {formUploading ? "Enviando..." : "Clique para anexar PDF"}
                    </p>
                  </div>
                )}
              </div>

              <DialogFooter>
                <Button type="button" variant="outline" onClick={handleCloseDialog}>
                  Cancelar
                </Button>
                <Button type="submit" className="bg-teal-600 hover:bg-teal-700" disabled={saving} data-testid="submit-btn">
                  {saving ? "Salvando..." : editingItem ? "Salvar" : "Criar"}
                </Button>
              </DialogFooter>
            </form>
          </DialogContent>
        </Dialog>

        {/* Certificados Dialog */}
        <Dialog open={certDialogOpen} onOpenChange={setCertDialogOpen}>
          <DialogContent className="sm:max-w-lg max-h-[90vh] overflow-y-auto">
            <DialogHeader>
              <DialogTitle style={{ fontFamily: 'Manrope' }}>
                <div className="flex items-center gap-2">
                  <FileText className="w-5 h-5 text-teal-600" />
                  Certificados de Calibração
                </div>
              </DialogTitle>
              <DialogDescription>
                {selectedItem?.nome_item} - Gerencie os certificados de calibração
              </DialogDescription>
            </DialogHeader>

            <div className="space-y-4">
              {/* Formulário de upload */}
              <Card className="border-dashed border-2">
                <CardContent className="p-4">
                  <h4 className="font-medium text-slate-900 mb-3">Adicionar novo certificado</h4>
                  <div className="space-y-3">
                    <div>
                      <Label htmlFor="certNome">Nome do certificado *</Label>
                      <Input
                        id="certNome"
                        value={certNome}
                        onChange={(e) => setCertNome(e.target.value)}
                        placeholder="Ex: Certificado de Calibração 2026"
                      />
                    </div>
                    <div>
                      <Label htmlFor="certValidade">Validade (opcional)</Label>
                      <Input
                        id="certValidade"
                        type="date"
                        value={certValidade}
                        onChange={(e) => setCertValidade(e.target.value)}
                      />
                    </div>
                    <div>
                      <input
                        type="file"
                        accept=".pdf"
                        ref={fileInputRef}
                        onChange={handleUploadCert}
                        className="hidden"
                        id="certFile"
                      />
                      <Button 
                        type="button"
                        onClick={() => {
                          if (!certNome.trim()) {
                            toast.error("Informe o nome do certificado primeiro");
                            return;
                          }
                          fileInputRef.current?.click();
                        }}
                        disabled={uploading}
                        className="w-full bg-teal-600 hover:bg-teal-700"
                      >
                        {uploading ? (
                          <>
                            <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                            Enviando...
                          </>
                        ) : (
                          <>
                            <Upload className="w-4 h-4 mr-2" />
                            Selecionar arquivo PDF
                          </>
                        )}
                      </Button>
                    </div>
                  </div>
                </CardContent>
              </Card>

              {/* Lista de certificados */}
              <div>
                <h4 className="font-medium text-slate-900 mb-3">
                  Certificados anexados ({selectedItem?.certificados?.length || 0})
                </h4>
                
                {(!selectedItem?.certificados || selectedItem.certificados.length === 0) ? (
                  <div className="text-center py-6 bg-slate-50 rounded-lg">
                    <FileText className="w-10 h-10 mx-auto text-slate-300 mb-2" />
                    <p className="text-sm text-slate-500">Nenhum certificado anexado</p>
                  </div>
                ) : (
                  <div className="space-y-2">
                    {selectedItem.certificados.map((cert) => {
                      const status = getCertStatus(cert.validade);
                      return (
                        <div 
                          key={cert.id} 
                          className={`flex items-center justify-between p-3 rounded-lg border ${
                            status === 'vencido' ? 'bg-red-50 border-red-200' :
                            status === 'vencendo' ? 'bg-amber-50 border-amber-200' :
                            'bg-white border-slate-200'
                          }`}
                        >
                          <div className="flex items-center gap-3 flex-1 min-w-0">
                            <FileText className={`w-8 h-8 shrink-0 ${
                              status === 'vencido' ? 'text-red-500' :
                              status === 'vencendo' ? 'text-amber-500' :
                              'text-teal-500'
                            }`} />
                            <div className="min-w-0">
                              <p className="font-medium text-slate-900 truncate">{cert.nome}</p>
                              <div className="flex items-center gap-2 text-xs text-slate-500">
                                <span>Enviado em {formatDate(cert.data_upload)}</span>
                                {cert.validade && (
                                  <span className={`px-1.5 py-0.5 rounded ${
                                    status === 'vencido' ? 'bg-red-100 text-red-700' :
                                    status === 'vencendo' ? 'bg-amber-100 text-amber-700' :
                                    'bg-emerald-100 text-emerald-700'
                                  }`}>
                                    {status === 'vencido' ? 'Vencido' : 
                                     status === 'vencendo' ? 'Vencendo' : 
                                     `Válido até ${formatDate(cert.validade)}`}
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="flex items-center gap-1 shrink-0">
                            <Button 
                              size="icon" 
                              variant="ghost"
                              onClick={() => handleDownloadCert(selectedItem.id, cert.arquivo)}
                              title="Baixar certificado"
                            >
                              <Download className="w-4 h-4 text-teal-600" />
                            </Button>
                            <Button 
                              size="icon" 
                              variant="ghost"
                              onClick={() => confirmDeleteCert(cert)}
                              title="Excluir certificado"
                            >
                              <Trash2 className="w-4 h-4 text-red-500" />
                            </Button>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>

            <DialogFooter>
              <Button variant="outline" onClick={() => setCertDialogOpen(false)}>
                Fechar
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>

        {/* Admin Password Dialog para Excluir Item */}
        <AdminPasswordDialog
          open={adminPasswordOpen}
          onOpenChange={(open) => {
            setAdminPasswordOpen(open);
            if (!open) {
              setDeleteId(null);
              setDeleteItemName("");
            }
          }}
          onConfirm={handleDelete}
          title="Excluir Item Calibrável"
          description="Esta ação não pode ser desfeita."
          itemName={deleteItemName}
        />

        {/* Admin Password Dialog para Excluir Certificado */}
        <AdminPasswordDialog
          open={adminPasswordCertOpen}
          onOpenChange={(open) => {
            setAdminPasswordCertOpen(open);
            if (!open) {
              setDeleteCertId(null);
              setDeleteCertName("");
            }
          }}
          onConfirm={handleDeleteCert}
          title="Excluir Certificado"
          description="O arquivo será removido permanentemente."
          itemName={deleteCertName}
        />

        {/* Add Setor Dialog */}
        <Dialog open={setorDialogOpen} onOpenChange={setSetorDialogOpen}>
          <DialogContent className="sm:max-w-md">
            <DialogHeader>
              <DialogTitle style={{ fontFamily: 'Manrope' }}>
                <div className="flex items-center gap-2">
                  <Settings className="w-5 h-5 text-teal-600" />
                  Gerenciar Setores
                </div>
              </DialogTitle>
              <DialogDescription>
                Adicione, edite ou remova setores
              </DialogDescription>
            </DialogHeader>
            <div className="space-y-4">
              {/* Adicionar novo */}
              <div className="flex gap-2">
                <Input
                  value={novoSetor}
                  onChange={(e) => setNovoSetor(e.target.value)}
                  placeholder="Nome do novo setor"
                  data-testid="input-novo-setor"
                  onKeyPress={(e) => e.key === 'Enter' && handleAddSetor()}
                />
                <Button 
                  onClick={handleAddSetor} 
                  className="bg-teal-600 hover:bg-teal-700"
                  disabled={!novoSetor.trim()}
                >
                  <Plus className="w-4 h-4" />
                </Button>
              </div>
              
              {/* Lista de setores */}
              <div className="space-y-2 max-h-60 overflow-y-auto">
                <p className="text-xs text-slate-500 font-medium">Setores cadastrados:</p>
                {setores.length === 0 ? (
                  <p className="text-sm text-slate-400 italic">Nenhum setor cadastrado</p>
                ) : (
                  setores.map((setor) => (
                    <div key={setor.value} className="flex items-center justify-between p-2 bg-slate-50 rounded hover:bg-slate-100">
                      <span className="text-sm">{setor.label}</span>
                      <Button 
                        size="icon" 
                        variant="ghost"
                        onClick={() => confirmDeleteSetor(setor)}
                        title="Excluir setor"
                      >
                        <Trash2 className="w-4 h-4 text-red-500" />
                      </Button>
                    </div>
                  ))
                )}
              </div>
            </div>
            <DialogFooter>
              <Button variant="outline" onClick={() => setSetorDialogOpen(false)}>
                Fechar
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>

        {/* Gerenciar Categorias Dialog */}
        <Dialog open={categoriaDialogOpen} onOpenChange={setCategoriaDialogOpen}>
          <DialogContent className="sm:max-w-md">
            <DialogHeader>
              <DialogTitle style={{ fontFamily: 'Manrope' }}>
                <div className="flex items-center gap-2">
                  <Settings className="w-5 h-5 text-teal-600" />
                  Gerenciar Categorias
                </div>
              </DialogTitle>
              <DialogDescription>
                Adicione, edite ou remova categorias de itens calibráveis
              </DialogDescription>
            </DialogHeader>
            <div className="space-y-4">
              {/* Adicionar nova */}
              <div className="flex gap-2">
                <Input
                  value={novaCategoria}
                  onChange={(e) => setNovaCategoria(e.target.value)}
                  placeholder="Nome da nova categoria"
                  data-testid="input-nova-categoria"
                  onKeyPress={(e) => e.key === 'Enter' && handleAddCategoria()}
                />
                <Button 
                  onClick={handleAddCategoria} 
                  className="bg-teal-600 hover:bg-teal-700"
                  disabled={!novaCategoria.trim()}
                >
                  <Plus className="w-4 h-4" />
                </Button>
              </div>
              
              {/* Lista de categorias */}
              <div className="space-y-2 max-h-60 overflow-y-auto">
                <p className="text-xs text-slate-500 font-medium">Categorias cadastradas:</p>
                {categorias.length === 0 ? (
                  <p className="text-sm text-slate-400 italic">Nenhuma categoria cadastrada</p>
                ) : (
                  categorias.map((cat) => (
                    <div key={cat.value} className="flex items-center justify-between p-2 bg-slate-50 rounded hover:bg-slate-100">
                      <span className="text-sm">{cat.label}</span>
                      <Button 
                        size="icon" 
                        variant="ghost"
                        onClick={() => confirmDeleteCategoria(cat)}
                        title="Excluir categoria"
                      >
                        <Trash2 className="w-4 h-4 text-red-500" />
                      </Button>
                    </div>
                  ))
                )}
              </div>
            </div>
            <DialogFooter>
              <Button variant="outline" onClick={() => setCategoriaDialogOpen(false)}>
                Fechar
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>

        {/* Admin Password Dialog para Excluir Categoria */}
        <AdminPasswordDialog
          open={adminPasswordCatOpen}
          onOpenChange={(open) => {
            setAdminPasswordCatOpen(open);
            if (!open) {
              setDeleteCategoriaId(null);
              setDeleteCategoriaName("");
            }
          }}
          onConfirm={handleDeleteCategoria}
          title="Excluir Categoria"
          description="Itens existentes manterão a categoria atual."
          itemName={deleteCategoriaName}
        />

        {/* Admin Password Dialog para Excluir Setor */}
        <AdminPasswordDialog
          open={adminPasswordSetorOpen}
          onOpenChange={(open) => {
            setAdminPasswordSetorOpen(open);
            if (!open) {
              setDeleteSetorId(null);
              setDeleteSetorName("");
            }
          }}
          onConfirm={handleDeleteSetor}
          title="Excluir Setor"
          description="Itens existentes manterão o setor atual."
          itemName={deleteSetorName}
        />

        {/* Modal de Filtros para Relatório */}
        <RelatorioFilterModal
          open={relatorioModalOpen}
          onOpenChange={setRelatorioModalOpen}
          title="Relatório de Itens Calibráveis"
          description="Selecione os filtros para gerar o relatório em PDF"
          endpoint="/pdf/itens"
          filters={[
            {
              key: "categoria",
              label: "Categoria",
              type: "select",
              options: categorias
            },
            {
              key: "setor",
              label: "Setor",
              type: "select",
              options: setores.map(s => ({ value: s.value, label: s.label }))
            },
            {
              key: "status",
              label: "Status",
              type: "select",
              options: [
                { value: "em_dia", label: "Em dia" },
                { value: "vencendo", label: "Vencendo" },
                { value: "vencido", label: "Vencido" }
              ]
            },
            {
              key: "data_inicio",
              label: "Próxima calibração a partir de",
              type: "date"
            },
            {
              key: "data_fim",
              label: "Próxima calibração até",
              type: "date"
            }
          ]}
        />

        {/* Dialog de confirmação de registro de verificações */}
        <ConfirmacaoRegistroDialog
          open={showConfirmacaoDialog}
          onOpenChange={setShowConfirmacaoDialog}
          onConfirmRegistrar={handleConfirmarVerificacoesRealizadas}
          onConfirmIgnorar={handleIgnorarVerificacoesHoje}
          tipo="item"
          nomeItem={itemRecemCriado?.nome_item || ""}
          detalhes={itemRecemCriado?.horarios_passados ? `Horários: ${itemRecemCriado.horarios_passados.join(", ")}` : ""}
        />

        {/* Dialog de Verificação de Balança */}
        <Dialog open={verificacaoBalancaOpen} onOpenChange={setVerificacaoBalancaOpen}>
          <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto" data-testid="verificacao-balanca-dialog">
            <DialogHeader>
              <DialogTitle className="flex items-center gap-2" style={{ fontFamily: 'Manrope' }}>
                <Scale className="w-5 h-5 text-teal-600" />
                Registrar Verificação de Balança
              </DialogTitle>
              <DialogDescription>
                Preencha os dados da verificação das {horarioVerificacaoAtual} para "{itemRecemCriado?.nome_item}"
                {horariosRestantes.length > 0 && (
                  <span className="block mt-1 text-amber-600">
                    ({horariosRestantes.length} verificação(ões) restante(s) após esta)
                  </span>
                )}
              </DialogDescription>
            </DialogHeader>
            <div className="space-y-4">
              <div className="grid grid-cols-2 gap-4">
                <div className="space-y-2">
                  <Label>Data *</Label>
                  <Input 
                    type="date" 
                    value={balancaForm.data_verificacao} 
                    onChange={(e) => handleBalancaChange("data_verificacao", e.target.value)} 
                  />
                </div>
                <div className="space-y-2">
                  <Label>Hora *</Label>
                  <Input 
                    type="time" 
                    value={balancaForm.hora_verificacao} 
                    onChange={(e) => handleBalancaChange("hora_verificacao", e.target.value)} 
                  />
                </div>
              </div>
              
              <div className="grid grid-cols-3 gap-4">
                <div className="space-y-2">
                  <Label>Peso Padrão (g) *</Label>
                  <Input 
                    type="number" 
                    step="0.0001" 
                    value={balancaForm.peso_padrao} 
                    onChange={(e) => handleBalancaChange("peso_padrao", e.target.value)} 
                    placeholder="100.0000" 
                    data-testid="input-peso-padrao"
                  />
                </div>
                <div className="space-y-2">
                  <Label>Peso Indicado (g) *</Label>
                  <Input 
                    type="number" 
                    step="0.0001" 
                    value={balancaForm.peso_indicado} 
                    onChange={(e) => handleBalancaChange("peso_indicado", e.target.value)} 
                    placeholder="100.0001" 
                    data-testid="input-peso-indicado"
                  />
                </div>
                <div className="space-y-2">
                  <Label>Diferença (g)</Label>
                  <Input 
                    type="text" 
                    value={balancaForm.diferenca} 
                    readOnly 
                    className="bg-slate-50" 
                  />
                </div>
              </div>
              
              <div className="space-y-2">
                <Label>Responsável *</Label>
                <Input 
                  value={balancaForm.responsavel} 
                  onChange={(e) => handleBalancaChange("responsavel", e.target.value)} 
                  placeholder="Nome do responsável" 
                  data-testid="input-responsavel-balanca"
                />
              </div>
              
              <div className="flex items-center gap-2">
                <Switch 
                  id="conforme-balanca-novo" 
                  checked={balancaForm.conforme} 
                  onCheckedChange={(checked) => handleBalancaChange("conforme", checked)} 
                />
                <Label htmlFor="conforme-balanca-novo">Conforme</Label>
              </div>
              
              <div className="space-y-2">
                <Label>Observações</Label>
                <Textarea 
                  value={balancaForm.observacoes} 
                  onChange={(e) => handleBalancaChange("observacoes", e.target.value)} 
                  placeholder="Observações adicionais..." 
                  rows={2} 
                />
              </div>
            </div>
            <DialogFooter className="flex-col sm:flex-row gap-2">
              <Button 
                variant="ghost" 
                onClick={handlePularVerificacao}
                disabled={verificacaoSaving}
              >
                {horariosRestantes.length > 0 ? "Pular esta" : "Cancelar"}
              </Button>
              <Button 
                onClick={handleSaveVerificacaoBalanca} 
                className="bg-teal-600 hover:bg-teal-700" 
                disabled={verificacaoSaving}
                data-testid="btn-salvar-verificacao-balanca"
              >
                {verificacaoSaving ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : null}
                Salvar Verificação
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>

        {/* Dialog de Verificação de Termohigrômetro */}
        <Dialog open={verificacaoTermoOpen} onOpenChange={setVerificacaoTermoOpen}>
          <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto" data-testid="verificacao-termo-dialog">
            <DialogHeader>
              <DialogTitle className="flex items-center gap-2" style={{ fontFamily: 'Manrope' }}>
                <Thermometer className="w-5 h-5 text-amber-600" />
                Registrar Verificação de Termohigrômetro
              </DialogTitle>
              <DialogDescription>
                Preencha os dados da verificação das {horarioVerificacaoAtual} para "{itemRecemCriado?.nome_item}"
                {horariosRestantes.length > 0 && (
                  <span className="block mt-1 text-amber-600">
                    ({horariosRestantes.length} verificação(ões) restante(s) após esta)
                  </span>
                )}
              </DialogDescription>
            </DialogHeader>
            <div className="space-y-4">
              <div className="grid grid-cols-2 gap-4">
                <div className="space-y-2">
                  <Label>Data *</Label>
                  <Input 
                    type="date" 
                    value={termoForm.data_verificacao} 
                    onChange={(e) => setTermoForm({ ...termoForm, data_verificacao: e.target.value })} 
                  />
                </div>
                <div className="space-y-2">
                  <Label>Hora *</Label>
                  <Input 
                    type="time" 
                    value={termoForm.hora_verificacao} 
                    onChange={(e) => setTermoForm({ ...termoForm, hora_verificacao: e.target.value })} 
                  />
                </div>
              </div>
              
              {itemRecemCriado && temFaixa(itemRecemCriado) && (
                <p className="text-xs text-slate-600" data-testid="termo-faixa-info-item">Faixa permitida: {descreverFaixa(itemRecemCriado)}</p>
              )}
              <div className="grid grid-cols-2 gap-4">
                <div className="space-y-2">
                  <Label>Temp. Mínima (°C) *</Label>
                  <Input type="number" step="0.1" value={termoForm.temperatura_min} onChange={(e) => atualizarTermo({ temperatura_min: e.target.value })} placeholder="18.0" data-testid="input-temperatura-min" />
                </div>
                <div className="space-y-2">
                  <Label>Temp. Máxima (°C) *</Label>
                  <Input type="number" step="0.1" value={termoForm.temperatura_max} onChange={(e) => atualizarTermo({ temperatura_max: e.target.value })} placeholder="25.0" data-testid="input-temperatura-max" />
                </div>
                <div className="space-y-2">
                  <Label>Temp. Atual (°C) *</Label>
                  <Input 
                    type="number" 
                    step="0.1" 
                    value={termoForm.temperatura_lida} 
                    onChange={(e) => atualizarTermo({ temperatura_lida: e.target.value })} 
                    placeholder="22.5" 
                    data-testid="input-temperatura"
                  />
                </div>
                <div className="space-y-2">
                  <Label>Umidade (%) *</Label>
                  <Input 
                    type="number" 
                    step="0.1" 
                    value={termoForm.umidade_lida} 
                    onChange={(e) => atualizarTermo({ umidade_lida: e.target.value })} 
                    placeholder="55.0" 
                    data-testid="input-umidade"
                  />
                </div>
              </div>
              {termoForaFaixa.length > 0 && (
                <div className="p-3 rounded-lg bg-red-50 border border-red-200 text-sm text-red-800 space-y-1" data-testid="termo-fora-faixa-alert-item">
                  <p className="font-semibold">Leitura fora da faixa permitida — marcada como não conforme</p>
                  <ul className="list-disc pl-5 text-xs">
                    {termoForaFaixa.map((m) => <li key={m}>{m}</li>)}
                  </ul>
                </div>
              )}
              
              <div className="space-y-2">
                <Label>Responsável *</Label>
                <Input 
                  value={termoForm.responsavel} 
                  onChange={(e) => setTermoForm({ ...termoForm, responsavel: e.target.value })} 
                  placeholder="Nome do responsável" 
                  data-testid="input-responsavel-termo"
                />
              </div>
              
              <div className="flex items-center gap-2">
                <Switch 
                  id="conforme-termo-novo" 
                  checked={termoForm.conforme} 
                  onCheckedChange={(checked) => setTermoForm({ ...termoForm, conforme: checked })} 
                />
                <Label htmlFor="conforme-termo-novo">Conforme</Label>
              </div>
              
              <div className="space-y-2">
                <Label>Observações</Label>
                <Textarea 
                  value={termoForm.observacoes} 
                  onChange={(e) => setTermoForm({ ...termoForm, observacoes: e.target.value })} 
                  placeholder="Observações adicionais..." 
                  rows={2} 
                />
              </div>
            </div>
            <DialogFooter className="flex-col sm:flex-row gap-2">
              <Button 
                variant="ghost" 
                onClick={handlePularVerificacao}
                disabled={verificacaoSaving}
              >
                {horariosRestantes.length > 0 ? "Pular esta" : "Cancelar"}
              </Button>
              <Button 
                onClick={handleSaveVerificacaoTermo} 
                className="bg-amber-600 hover:bg-amber-700" 
                disabled={verificacaoSaving}
                data-testid="btn-salvar-verificacao-termo"
              >
                {verificacaoSaving ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : null}
                Salvar Verificação
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      </div>
    </Layout>
  );
};

export default ItensList;
